module.exports = __webpack_public_path__ + "img/Arrow up Icon - charcoal.66f02a0c.svg";